/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 支払通知書Zipアップロード結果のメタ情報
 * @export
 * @interface GetOperationNotice200Response
 */
export interface GetOperationNotice200Response {
    /**
     * アップロード操作ID
     * @type {string}
     * @memberof GetOperationNotice200Response
     */
    operationUploadId: string;
    /**
     * アップロード日時
     * @type {Date}
     * @memberof GetOperationNotice200Response
     */
    uploadedAt: Date;
    /**
     * Zip内のファイル数
     * @type {number}
     * @memberof GetOperationNotice200Response
     */
    fileCount: number;
    /**
     * Zip内のファイル名一覧
     * @type {Array<string>}
     * @memberof GetOperationNotice200Response
     */
    fileNames: Array<string>;
    /**
     * 対象の支払業務ID
     * @type {string}
     * @memberof GetOperationNotice200Response
     */
    operationId: string;
    /**
     * アップロード総額 (検算用)
     * @type {number}
     * @memberof GetOperationNotice200Response
     */
    amount: number;
    /**
     * 検算に成功したファイル数
     * @type {number}
     * @memberof GetOperationNotice200Response
     */
    successCount: number;
    /**
     * 検算結果が正しいかどうかのフラグ
     * @type {boolean}
     * @memberof GetOperationNotice200Response
     */
    isOk: boolean;
}

/**
 * Check if a given object implements the GetOperationNotice200Response interface.
 */
export function instanceOfGetOperationNotice200Response(value: object): value is GetOperationNotice200Response {
    if (!('operationUploadId' in value) || value['operationUploadId'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    if (!('fileCount' in value) || value['fileCount'] === undefined) return false;
    if (!('fileNames' in value) || value['fileNames'] === undefined) return false;
    if (!('operationId' in value) || value['operationId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('successCount' in value) || value['successCount'] === undefined) return false;
    if (!('isOk' in value) || value['isOk'] === undefined) return false;
    return true;
}

export function GetOperationNotice200ResponseFromJSON(json: any): GetOperationNotice200Response {
    return GetOperationNotice200ResponseFromJSONTyped(json, false);
}

export function GetOperationNotice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOperationNotice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'operationUploadId': json['operation_upload_id'],
        'uploadedAt': (new Date(json['uploaded_at'])),
        'fileCount': json['file_count'],
        'fileNames': json['file_names'],
        'operationId': json['operation_id'],
        'amount': json['amount'],
        'successCount': json['success_count'],
        'isOk': json['is_ok'],
    };
}

export function GetOperationNotice200ResponseToJSON(json: any): GetOperationNotice200Response {
    return GetOperationNotice200ResponseToJSONTyped(json, false);
}

export function GetOperationNotice200ResponseToJSONTyped(value?: GetOperationNotice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_upload_id': value['operationUploadId'],
        'uploaded_at': ((value['uploadedAt']).toISOString()),
        'file_count': value['fileCount'],
        'file_names': value['fileNames'],
        'operation_id': value['operationId'],
        'amount': value['amount'],
        'success_count': value['successCount'],
        'is_ok': value['isOk'],
    };
}

